// extracted by mini-css-extract-plugin
var _1 = "styles-module__active___vQN6t";
var _2 = "styles-module__explore___dppZY";
var _3 = "styles-module__tab___D9FEg";
var _4 = "styles-module__tabBar___ABu_G";
export { _1 as "active", _2 as "explore", _3 as "tab", _4 as "tabBar" }
